class SetMenuType {
	body: HTMLElement | null;
	utilityToggleLinks?: NodeListOf<HTMLElement> | null;
	patientsToggleLink?: NodeListOf<HTMLElement> | null;

	constructor() {
		this.body = document.querySelector('body');
		this.utilityToggleLinks = document.querySelectorAll('.utility-nav--item a');
		this.patientsToggleLink = document.querySelectorAll('.patients-toggle');
		this.setLocalStorage = this.setLocalStorage.bind(this);
		this.getLocalStorage = this.getLocalStorage.bind(this);
		this.resetLocalStorage = this.resetLocalStorage.bind(this);
	}

	init(): void {
		window.addEventListener('load', this.setLocalStorage);
		window.addEventListener('load', this.getLocalStorage);
		this.patientsToggleLink?.forEach((btn) => {
			btn?.addEventListener('click', this.resetLocalStorage);
		});
	}

	setLocalStorage(): void {
		const urlPath = window.location.pathname;
		if (urlPath.includes('/providers/')) {
			localStorage.setItem('menu-type', 'providers');
		} else if (urlPath.includes('/patients/')) {
			localStorage.setItem('menu-type', 'patients');
		}
	}

	getLocalStorage(): void {
		const urlPath = window.location.pathname;
		if (!urlPath.includes('/providers/') && !urlPath.includes('/patients/')) {
			const menuType = localStorage.getItem('menu-type');

			if (menuType === 'providers') {
				this.body?.classList.remove('hide-providers');
				this.body?.classList.add('hide-patients');

				if (this.utilityToggleLinks) {
					this.utilityToggleLinks.forEach((link) => {
						if (link.classList.contains('patients-toggle')) {
							link.classList.remove('utility-nav--item--active');
						} else {
							link.classList.add('utility-nav--item--active');
						}
					});
				}
			}
		}
	}

	resetLocalStorage(): void {
		localStorage.removeItem('menu-type');
	}
}

export default new SetMenuType();
